<app-setting-tag-item [isNew]="true" [tag]="emptyTag"></app-setting-tag-item>
@for (tag of tags(); track tag) {
  <app-setting-tag-item [tag]="tag"></app-setting-tag-item>
}
